import { lazy } from "react";
import { Navigate, Outlet, RouteObject } from "react-router-dom";
import AdminRoute from "../components/routes/AdminRoute";

const Home = lazy(() => import('../pages/admin/HomePage'));
const Login = lazy(() => import('../pages/admin/LoginPage'));
const Forbidden = lazy(() => import('../pages/admin/ForbiddenPage'));
const Error = lazy(() => import('../pages/admin/ErrorPage'));

// const Content = lazy(() => import('../pages/admin/website/ContentPage'));
// const AddContent = lazy(() => import('../pages/admin/website/AddContentPage'));
// const EditContent = lazy(() => import('../pages/admin/website/EditContentPage'));

const SightingDataPage = lazy(() => import('../pages/admin/export/SightingDataPage'));

export const AdminRoutes: RouteObject[] = [
    {
        index: true,
        element: (    
            <AdminRoute>
                <Home />
            </AdminRoute>
        )
    },
    // {
    //     path: 'content',
    //     element: (
    //         <AdminRoute>
    //             <Outlet />
    //         </AdminRoute>
    //     ),
    //     children: [
    //         {
    //             index: true,
    //             element: <Content />
    //         },
    //         {
    //             path: 'add',
    //             element: <AddContent />
    //         },
    //         {
    //             path: 'edit',
    //             element: <EditContent />
    //         }
    //     ]
    // },
    {
        path: 'export',
        element: (
            <AdminRoute>
                <Outlet />
            </AdminRoute>
        ),
        children: [
            {
                index: true,
                element: <Navigate to={"sighting"} />
            },
            {
                path: "sighting",
                element: <SightingDataPage />
            }
        ]
    },
    {
        path: 'login',
        element: <Login />,
        children: []
    },
    {
        path: 'forbidden',
        element: <Forbidden />
    },
    {
        path: 'error',
        element: <Error />
    }
];